<template>
  <div class="po-exchange-table-wrap">
    <div v-if="!rows.length" class="text-center text-muted py-5">
      Chưa có dòng nào — quét IMEI hoặc tên sản phẩm ở thanh tìm kiếm phía trên.
    </div>

  <!-- Desktop table -->
    <table v-else class="table table-bordered table-sm d-none d-md-table mb-0 po-exchange-table">
      <colgroup>
        <col style="width: 27%" />
        <col style="width: 22%" />
        <col style="width: 27%" />
        <col style="width: 22%" />
        <col style="width: 48px" />
      </colgroup>
      <thead>
        <tr>
          <th colspan="2" class="po-group-header-export">
            <i class="mdi mdi-arrow-left"></i> HÀNG XUẤT
          </th>
          <th colspan="3" class="po-group-header-import">
            <i class="mdi mdi-arrow-right"></i> HÀNG NHẬP
          </th>
        </tr>
        <tr class="po-col-header">
          <th>Sản phẩm</th>
          <th>IMEI</th>
          <th>Sản phẩm</th>
          <th>IMEI</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="row.id">
          <td>
            <div class="po-product-line">
              <span class="po-row-index">{{ index + 1 }}.</span>
              <ProductionOrderProductCell
                :product-id="row.productId"
                :product-name="row.productName"
                :product-code="row.productCode"
                :bar-code="row.barCode"
                :image-url="row.productImageUrl"
              />
            </div>
          </td>
          <td>
            <ProductionOrderImeiCell :value="row.imeiOld" locked />
          </td>
          <td>
            <ProductionOrderProductCell
              v-if="mode === 'change-product'"
              :editable="true"
              :product-id="row.productIdNew"
              :product-name="row.productNameNew"
              :product-code="row.productCodeNew"
              :bar-code="row.barCodeNew"
              :image-url="row.productImageUrlNew"
              :search-text="row.productNameNew"
              :suggestions="productNewSuggestions"
              :show-price="showPrice"
              @search-input="$emit('product-new-search', $event, index)"
              @selected="$emit('product-new-selected', $event, index)"
              @focus="$emit('product-new-focus', index)"
            />
            <ProductionOrderProductCell
              v-else
              :product-id="row.productId"
              :product-name="row.productName"
              :product-code="row.productCode"
              :bar-code="row.barCode"
              :image-url="row.productImageUrl"
              badge="Sản phẩm giữ nguyên"
            />
          </td>
          <td>
            <ProductionOrderImeiCell
              v-if="mode === 'change-product'"
              :value="row.imeiOld"
              locked
              hint="IMEI giữ nguyên"
            />
            <ProductionOrderImeiCell
              v-else
              :value="row.imeiNew"
              :locked="false"
              :error="row.fieldErrors.imeiNew"
              @input="$emit('imei-new-input', $event, index)"
            />
          </td>
          <td class="text-center align-middle">
            <button type="button" class="po-remove-btn" @click="$emit('remove-row', row.id)">
              <i class="mdi mdi-trash-can-outline"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Mobile cards -->
    <div class="d-md-none">
      <div v-for="(row, index) in rows" :key="'m-' + row.id" class="mb-3">
        <div class="po-row-card po-row-card-export">
          <div class="font-weight-bold text-danger mb-2">Hàng xuất</div>
          <ProductionOrderProductCell
            :product-id="row.productId"
            :product-name="row.productName"
            :product-code="row.productCode"
            :bar-code="row.barCode"
            :image-url="row.productImageUrl"
          />
          <div class="mt-2">
            <ProductionOrderImeiCell :value="row.imeiOld" locked />
          </div>
        </div>
        <div class="po-row-card po-row-card-import">
          <div class="font-weight-bold text-success mb-2">Hàng nhập</div>
          <ProductionOrderProductCell
            v-if="mode === 'change-product'"
            :editable="true"
            :product-id="row.productIdNew"
            :product-name="row.productNameNew"
            :product-code="row.productCodeNew"
            :bar-code="row.barCodeNew"
            :image-url="row.productImageUrlNew"
            :search-text="row.productNameNew"
            :suggestions="productNewSuggestions"
            :show-price="showPrice"
            @search-input="$emit('product-new-search', $event, index)"
            @selected="$emit('product-new-selected', $event, index)"
            @focus="$emit('product-new-focus', index)"
          />
          <ProductionOrderProductCell
            v-else
            :product-id="row.productId"
            :product-name="row.productName"
            :product-code="row.productCode"
            :bar-code="row.barCode"
            :image-url="row.productImageUrl"
            badge="Sản phẩm giữ nguyên"
          />
          <div class="mt-2">
            <ProductionOrderImeiCell
              v-if="mode === 'change-product'"
              :value="row.imeiOld"
              locked
              hint="IMEI giữ nguyên"
            />
            <ProductionOrderImeiCell
              v-else
              :value="row.imeiNew"
              :locked="false"
              :error="row.fieldErrors.imeiNew"
              @input="$emit('imei-new-input', $event, index)"
            />
          </div>
          <div class="text-right mt-2">
            <button type="button" class="po-remove-btn" @click="$emit('remove-row', row.id)">
              <i class="mdi mdi-trash-can-outline"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductionOrderProductCell from './ProductionOrderProductCell.vue';
import ProductionOrderImeiCell from './ProductionOrderImeiCell.vue';

export default {
  name: 'ProductionOrderExchangeTable',
  components: {
    ProductionOrderProductCell,
    ProductionOrderImeiCell,
  },
  props: {
    rows: { type: Array, default: () => [] },
    mode: { type: String, default: 'change-product' },
    productNewSuggestions: { type: Array, default: () => [{ data: [] }] },
    showPrice: { type: Boolean, default: true },
  },
};
</script>
